<template>
  <div class="the-content-page">
    <div class="m-6 the-content-page-sub bg-white rounded-lg">
      <router-view testek="the-content"></router-view>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.the-content-page {
  background: #f9f9f9;
  .the-content-page-sub {
    height: calc(100% - 48px);
  }
}
</style>
